module.exports = __webpack_public_path__ + "static/media/WU_PAYMENT_cash_inactive.f6fdd0f9.svg";